import React, { useEffect } from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Hero } from './components/Hero';
import { SuccessAddsWeight } from './components/SuccessAddsWeight';
import { WhoThisIsFor } from './components/WhoThisIsFor';
import { WhoThisIsNotFor } from './components/WhoThisIsNotFor';
import { Solution } from './components/Solution';
import { FoundationCheck } from './components/FoundationCheck';
import { Outcome } from './components/Outcome';
import { Credibility } from './components/Credibility';
import { Pathway } from './components/Pathway';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { FinalCta } from './components/FinalCta';
export function App() {
  useEffect(() => {
    document.title = 'Unified Success Masterclass';
  }, []);
  return <div className="min-h-screen w-full bg-ink font-sans text-white antialiased" data-id="element-0" data-mp="28t4k8aooa4rf">
      <AnnouncementBar data-id="element-1" data-mp="23u9tmmkgrbwr" />
      <main data-id="element-2" data-mp="23utadzydnu97">
        <Hero data-id="element-3" data-mp="23t8i6gzjcnei" />
        <SuccessAddsWeight data-id="element-4" data-mp="23ti5fwt74ggi" />
        <WhoThisIsFor data-id="element-5" data-mp="3ikh5q2ysagvt" />
        <WhoThisIsNotFor data-id="element-6" data-mp="3ij66mgga9xb1" />
        <Solution data-id="element-7" data-mp="3ihv2gfixenje" />
        <FoundationCheck data-id="element-8" data-mp="3mljaezbgzl56" />
        <Outcome data-id="element-9" data-mp="3mkrdnl64zhdb" />
        <Credibility data-id="element-10" data-mp="3mk8710lxsfel" />
        <Pathway data-id="element-11" data-mp="3mjq3diwy2ywn" />
        <Urgency data-id="element-12" data-mp="3mj6k9yvk64h1" />
        <Pricing data-id="element-13" data-mp="3rcj7c4kla37o" />
        <FinalCta data-id="element-14" data-mp="3rbzo8kj7d8s2" />
      </main>
    </div>;
}